import React from 'react';
import ReactModal from 'react-modal';
import { List } from 'immutable';
import orderBy from 'lodash/orderBy';
import format from 'date-fns/format';
import DayPicker from 'react-day-picker/DayPicker';
import Media from 'react-media';
import Button from '../../buttons/BasicButton/';

import { ProjectActions } from '../../../actions/project';
import { parseISO } from 'date-fns';

if (__CLIENT__) {
  require('./style.css');
}

class ProjectCalendarDisplayTableRow extends React.Component {
  _callback = () => {
    const { date, removeHoliday } = this.props;

    removeHoliday(date);
  };
  render() {
    const { date } = this.props;

    return (
      <tr>
        <td className="col-10">{date}</td>
        <td className="col-2">
          <button
            type="button"
            className="close"
            aria-label="Close"
            style={{ cursor: 'pointer' }}
            onClick={this._callback}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </td>
      </tr>
    );
  }
}

class ProjectCalendarDisplay extends React.Component {
  render() {
    const {
      holidayList,
      currentYear,
      changeYearForward,
      changeYearBackward,
      removeHoliday,
    } = this.props;

    const tableRows =
      holidayList.length > 0
        ? holidayList.reduce((p, date, index) => {
            return p.concat(
              <ProjectCalendarDisplayTableRow
                key={index}
                date={date}
                removeHoliday={removeHoliday}
              />,
            );
          }, [])
        : [
            <tr key={1}>
              <td className="col-12">No Holidays Set for {currentYear}</td>
            </tr>,
          ];

    return (
      <div>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div
            onClick={changeYearBackward}
            style={{
              width: '10%',
              display: 'flex',
              justifyContent: 'flex-start',
            }}
          >
            <span
              role="button"
              aria-label="Previous Year"
              className="DayPicker-NavButton YearPicker-NavButton--prev"
            />
          </div>
          <div
            style={{
              width: '80%',
              display: 'flex',
              justifyContent: 'center',
              fontSize: 20,
              fontWeight: 'bold',
              verticalAlign: 'middle',
            }}
          >
            {currentYear}
          </div>
          <div
            onClick={changeYearForward}
            style={{
              width: '10%',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <span
              role="button"
              aria-label="Next Year"
              className="DayPicker-NavButton YearPicker-NavButton--next"
            />
          </div>
        </div>
        <div
          style={{
            marginTop: '1rem',
            marginBottom: '0rem',
            border: 0,
            borderTop: '1px solid rgba(0, 0, 0, 0.1)',
          }}
        />
        <table className="table table-striped" id="selected-dates">
          <tbody>{tableRows}</tbody>
        </table>
      </div>
    );
  }
}

class ProjectCalendarModal extends React.Component {
  constructor(props) {
    super(props);

    const holidayList = props.value || List();
    const initialData = [];

    const stubData = holidayList.sortBy(a => a).reduce((acc, jsondate) => {
      const date = format(parseISO(jsondate), 'MM/dd/yyyy');
      const year = format(parseISO(jsondate), 'yyyy');
      initialData.push(date);

      const yearArray = acc[year] || [];

      acc[year] = yearArray.concat(date);

      return acc;
    }, {});

    this.state = {
      datesArray: stubData,
      currentYear: format(new Date(), 'yyyy'),
      initialData,
      disabledButton: true,
    };
  }

  changeYearForward = () => {
    const { currentYear } = this.state;

    this.setState({
      currentYear: (parseInt(currentYear, 10) + 1).toString(),
    });
  };

  changeYearBackward = () => {
    const { currentYear } = this.state;

    this.setState({
      currentYear: (parseInt(currentYear, 10) - 1).toString(),
    });
  };

  handleMonthChange = e => {
    const { currentYear } = this.state;

    const formattedDateYear = format(e, 'yyyy');

    if (currentYear !== formattedDateYear) {
      this.setState({
        currentYear: formattedDateYear,
      });
    }
  };

  compareInitialToCurrent = (initialData, yearArray) => {
    if (initialData.length !== yearArray.length) {
      this.setState({
        disabledButton: false,
      });
    } else {
      let lastFoundIndex = 0;
      let yearArrayIndex = yearArray.length - 1;

      while (yearArrayIndex > -1 && lastFoundIndex !== -1) {
        lastFoundIndex = initialData.indexOf(yearArray[yearArrayIndex]);

        yearArrayIndex = yearArrayIndex - 1;
      }

      if (lastFoundIndex === -1) {
        this.setState({
          disabledButton: false,
        });
      } else {
        this.setState({
          disabledButton: true,
        });
      }
    }
  };

  removeHoliday = date => {
    const { currentYear, datesArray, initialData } = this.state;

    const yearArray = datesArray[currentYear] || [];

    const indexOfDate = yearArray.indexOf(date);

    if (indexOfDate > -1) {
      yearArray.splice(indexOfDate, 1);
    }

    this.compareInitialToCurrent(initialData, yearArray);

    datesArray[currentYear] = yearArray;

    this.setState({
      datesArray,
    });
  };

  handleDayClick = e => {
    const { datesArray, initialData } = this.state;

    const date = format(e, 'MM/dd/yyyy');
    const formattedDateYear = format(e, 'yyyy');

    const yearArray = datesArray[formattedDateYear] || [];
    const indexOfDate = yearArray.indexOf(date);

    if (indexOfDate > -1) {
      yearArray.splice(indexOfDate, 1);
    } else {
      yearArray.splice(yearArray.length, 0, date);
    }

    this.compareInitialToCurrent(initialData, yearArray);

    datesArray[formattedDateYear] = orderBy(yearArray, a => a);

    this.setState({
      datesArray,
    });
  };

  submitHolidays = () => {
    const { datesArray } = this.state;
    const { dispatch, currentProjectId, handleCloseModal } = this.props;

    const newInitialDatesArray = [];
    const newDatesArray = Object.keys(datesArray).reduce((p, c) => {
      return p.concat(
        datesArray[c].map(d => {
          newInitialDatesArray.push(d);
          const date = new Date(d).toJSON();
          return `${date.slice(0, date.indexOf('T'))}T12:00:00.000Z`;
        }),
      );
    }, []);

    const options = {
      props: {
        'Project Calendar': newDatesArray,
      },
    };

    dispatch(
      ProjectActions.updateCustomProperty(currentProjectId, options),
    ).then(res => {
      if (res) handleCloseModal();
      this.setState({
        initialData: newInitialDatesArray,
        disabledButton: true,
      });
    });
  };

  render() {
    const { showModal, contentLabel, handleCloseModal } = this.props;

    const { datesArray, currentYear, disabledButton } = this.state;

    const testing = Object.keys(datesArray).reduce(
      (p, c) =>
        p.concat(datesArray[c].reduce((p1, c1) => p1.concat(new Date(c1)), [])),
      [],
    );

    return (
      <Media query="(max-width: 992px)">
        {matches => (
          <ReactModal
            isOpen={showModal}
            contentLabel={contentLabel}
            style={{
              overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                overflowY: 'auto',
              },
              content: {
                marginLeft: 'auto',
                marginRight: 'auto',
                padding: 0,
                border: 'none',
                bottom: 'auto',
                borderRadius: 4,
                maxWidth: matches ? '90vw' : '60vw',
                maxHeight: '90vh',
              },
            }}
          >
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#eee' }}>
                <h5 className="modal-title">Project Calendar</h5>
                <button
                  onClick={handleCloseModal}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i
                    className="fa fa fa-times"
                    style={{ fontSize: '1.3em', color: '#808080' }}
                  />
                </button>
              </div>
              <div
                className="modal-body holiday"
                style={{ display: 'flex', flexDiration: 'column' }}
              >
                <div>
                  <DayPicker
                    selectedDays={testing}
                    style={{ zIndex: 100 }}
                    onDayClick={this.handleDayClick}
                    onDayChange={this.handleDayChange}
                    onMonthChange={this.handleMonthChange}
                  />
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      disabled={disabledButton}
                      className="btn btn-primary"
                      callback={this.submitHolidays}
                      data-test="saveProjectCalendar"
                    >
                      Save Project Calendar
                    </Button>
                  </div>
                </div>
                <div>
                  <ProjectCalendarDisplay
                    holidayList={datesArray[currentYear] || []}
                    currentYear={currentYear}
                    changeYearForward={this.changeYearForward}
                    changeYearBackward={this.changeYearBackward}
                    removeHoliday={this.removeHoliday}
                  />
                </div>
              </div>
              <div
                className="modal-footer"
                style={{ backgroundColor: '#eee', padding: 0 }}
              />
            </div>
          </ReactModal>
        )}
      </Media>
    );
  }
}

class Display extends React.Component {
  state = {
    open: false,
  };

  handleClick = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    const { value, currentProjectId, dispatch } = this.props;

    return (
      <div style={{ display: 'flex' }}>
        <button className="btn btn-link" onClick={this.handleClick}>
          Show Calendar
        </button>
        <ProjectCalendarModal
          showModal={this.state.open}
          value={value}
          handleCloseModal={this.handleClose}
          contentLabel={'ProjectCalendar'}
          dispatch={dispatch}
          currentProjectId={currentProjectId}
        />
      </div>
    );
  }
}

const ProjectCalendar = {
  designer: () => <div />,

  display: ({ toggleEditor, userMode, value, currentProjectId, dispatch }) => {
    return (
      <Display
        value={value}
        currentProjectId={currentProjectId}
        dispatch={dispatch}
      />
    );
  },

  editor: () => <div />,
};

export default ProjectCalendar;



// WEBPACK FOOTER //
// ./src/components/types/ProjectCalendar/index.js